module.exports = __webpack_public_path__ + "img/img.d455f8c4.png";